export default "__VITE_ASSET__88deb5b5__"